// extracted by mini-css-extract-plugin
export default {"root":"styles_root__2cf1I","debugContainer":"styles_debugContainer__QLLYi","buttonContainer":"styles_buttonContainer__jkqyh","debugButton":"styles_debugButton__7uHUa"};